import React from 'react';
import { Box } from '@mui/material';
import { FaArrowLeft } from 'react-icons/fa';
import PropTypes from 'prop-types';
import { 
  Container, 
  Header, 
  HeaderLeft, 
  BackButton, 
  Title, 
  Content, 
  MainSection
} from '../../../common/styles';
import EmptyState from '../../../common/EmptyState';

const CVErrorState = ({ 
  errorMessage, 
  onBack, 
  backButtonText = 'Back to Repository'
}) => {
  return (
    <Container>
      <Header>
        <HeaderLeft>
          <BackButton onClick={onBack}>
            <FaArrowLeft /> {backButtonText}
          </BackButton>
          <Title>CV Error</Title>
        </HeaderLeft>
      </Header>
      <Content>
        <MainSection>
          <EmptyState
            title="Failed to Load CV"
            description={errorMessage || "An error occurred while loading the CV data. Please try again or contact support if the problem persists."}
          />
        </MainSection>
      </Content>
    </Container>
  );
};

CVErrorState.propTypes = {
  errorMessage: PropTypes.string,
  onBack: PropTypes.func.isRequired,
  backButtonText: PropTypes.string
};

export default CVErrorState; 